'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// walrus
import Box, { BoxProps } from '@components/kit/box'

// lib
import FilterPill from './filter-pill'

/* -----------------------------------------------------------------------------
 * FilterPillGroup
 * -------------------------------------------------------------------------- */

export type FilterPillOption = {
  label: string
  value: string
}

export type FilterPillGroupProps = BoxProps & {
  onSelect: (value: string) => void
  options: FilterPillOption[]
  trailing?: React.ReactNode
  value: string
}

function FilterPillGroup({
  onSelect,
  options,
  trailing,
  value,
  ...otherProps
}: FilterPillGroupProps) {
  return (
    <Box
      alignItems='center'
      flexDirection='row'
      flexWrap='wrap'
      gap='08'
      {...otherProps}
    >
      {options.map(option => (
        <FilterPill
          key={option.value}
          label={option.label}
          onPress={() => onSelect(option.value)}
          selected={option.value === value}
        />
      ))}
      {trailing ? <Box ml='auto'>{trailing}</Box> : null}
    </Box>
  )
}

export default FilterPillGroup
